/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSON,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSONTyped,
    DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsToJSON,
    DigitizingserviceMelcoModelsCustomWarning,
    DigitizingserviceMelcoModelsCustomWarningFromJSON,
    DigitizingserviceMelcoModelsCustomWarningFromJSONTyped,
    DigitizingserviceMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderResponse {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    instructions?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    is_sew_out?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    measurement_unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    po_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    product_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    location_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    fabric_color_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    fabric_color_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    fabric_color_hex?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    fabric_type_ids?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    emb_outline_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    emb_outline_format_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    thread_supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    thread_manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    delivery_option_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    delivery_hours?: number;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    due_date?: Date | null;
    /**
     * 
     * @type {DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    design_adaptions?: DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    digitizing_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    sew_out_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    subtotal?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    coupon_code?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    coupon_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    preview_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    file_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    stitch_count?: number;
    /**
     * 
     * @type {Array<DigitizingserviceMelcoModelsCustomWarning>}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    warning_list?: Array<DigitizingserviceMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    design_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    product_type_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    location_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    fabric_type_names?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    order_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    client_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    created_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderResponse
     */
    is_payment_done?: boolean;
}

export function DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderResponse {
    return DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
        'is_sew_out': !exists(json, 'is_sew_out') ? undefined : json['is_sew_out'],
        'measurement_unit': !exists(json, 'measurement_unit') ? undefined : json['measurement_unit'],
        'po_number': !exists(json, 'po_number') ? undefined : json['po_number'],
        'product_type_id': !exists(json, 'product_type_id') ? undefined : json['product_type_id'],
        'location_id': !exists(json, 'location_id') ? undefined : json['location_id'],
        'fabric_color_id': !exists(json, 'fabric_color_id') ? undefined : json['fabric_color_id'],
        'fabric_color_name': !exists(json, 'fabric_color_name') ? undefined : json['fabric_color_name'],
        'fabric_color_hex': !exists(json, 'fabric_color_hex') ? undefined : json['fabric_color_hex'],
        'fabric_type_ids': !exists(json, 'fabric_type_ids') ? undefined : json['fabric_type_ids'],
        'emb_outline_format_id': !exists(json, 'emb_outline_format_id') ? undefined : json['emb_outline_format_id'],
        'emb_outline_format_name': !exists(json, 'emb_outline_format_name') ? undefined : json['emb_outline_format_name'],
        'thread_supplier_id': !exists(json, 'thread_supplier_id') ? undefined : json['thread_supplier_id'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'thread_manufacturer': !exists(json, 'thread_manufacturer') ? undefined : json['thread_manufacturer'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'delivery_option_name': !exists(json, 'delivery_option_name') ? undefined : json['delivery_option_name'],
        'delivery_hours': !exists(json, 'delivery_hours') ? undefined : json['delivery_hours'],
        'due_date': !exists(json, 'due_date') ? undefined : (json['due_date'] === null ? null : new Date(json['due_date'])),
        'design_adaptions': !exists(json, 'design_adaptions') ? undefined : DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSON(json['design_adaptions']),
        'digitizing_amount': !exists(json, 'digitizing_amount') ? undefined : json['digitizing_amount'],
        'sew_out_amount': !exists(json, 'sew_out_amount') ? undefined : json['sew_out_amount'],
        'subtotal': !exists(json, 'subtotal') ? undefined : json['subtotal'],
        'coupon_code': !exists(json, 'coupon_code') ? undefined : json['coupon_code'],
        'coupon_amount': !exists(json, 'coupon_amount') ? undefined : json['coupon_amount'],
        'preview_url': !exists(json, 'preview_url') ? undefined : json['preview_url'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'stitch_count': !exists(json, 'stitch_count') ? undefined : json['stitch_count'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'design_name': !exists(json, 'design_name') ? undefined : json['design_name'],
        'product_type_name': !exists(json, 'product_type_name') ? undefined : json['product_type_name'],
        'location_name': !exists(json, 'location_name') ? undefined : json['location_name'],
        'fabric_type_names': !exists(json, 'fabric_type_names') ? undefined : json['fabric_type_names'],
        'order_status': !exists(json, 'order_status') ? undefined : json['order_status'],
        'client_name': !exists(json, 'client_name') ? undefined : json['client_name'],
        'created_date': !exists(json, 'created_date') ? undefined : (json['created_date'] === null ? null : new Date(json['created_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'is_payment_done': !exists(json, 'is_payment_done') ? undefined : json['is_payment_done'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'height': value.height,
        'width': value.width,
        'instructions': value.instructions,
        'is_sew_out': value.is_sew_out,
        'measurement_unit': value.measurement_unit,
        'po_number': value.po_number,
        'product_type_id': value.product_type_id,
        'location_id': value.location_id,
        'fabric_color_id': value.fabric_color_id,
        'fabric_color_name': value.fabric_color_name,
        'fabric_color_hex': value.fabric_color_hex,
        'fabric_type_ids': value.fabric_type_ids,
        'emb_outline_format_id': value.emb_outline_format_id,
        'emb_outline_format_name': value.emb_outline_format_name,
        'thread_supplier_id': value.thread_supplier_id,
        'supplier_product_id': value.supplier_product_id,
        'thread_manufacturer': value.thread_manufacturer,
        'delivery_option_id': value.delivery_option_id,
        'delivery_option_name': value.delivery_option_name,
        'delivery_hours': value.delivery_hours,
        'due_date': value.due_date === undefined ? undefined : (value.due_date === null ? null : value.due_date.toISOString()),
        'design_adaptions': DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsToJSON(value.design_adaptions),
        'digitizing_amount': value.digitizing_amount,
        'sew_out_amount': value.sew_out_amount,
        'subtotal': value.subtotal,
        'coupon_code': value.coupon_code,
        'coupon_amount': value.coupon_amount,
        'preview_url': value.preview_url,
        'file_name': value.file_name,
        'stitch_count': value.stitch_count,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingserviceMelcoModelsCustomWarningToJSON)),
        'id': value.id,
        'design_name': value.design_name,
        'product_type_name': value.product_type_name,
        'location_name': value.location_name,
        'fabric_type_names': value.fabric_type_names,
        'order_status': value.order_status,
        'client_name': value.client_name,
        'created_date': value.created_date === undefined ? undefined : (value.created_date === null ? null : value.created_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'is_payment_done': value.is_payment_done,
    };
}


